import { render, staticRenderFns } from "./EditUser.vue?vue&type=template&id=08ba8c1a&scoped=true"
import script from "./EditUser.vue?vue&type=script&lang=ts"
export * from "./EditUser.vue?vue&type=script&lang=ts"
import style0 from "./EditUser.vue?vue&type=style&index=0&id=08ba8c1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ba8c1a",
  null
  
)

export default component.exports